import styled from 'styled-components';

import {
  colorBlack900,
  colorGrayLight,
  colorBlueGray,
  colorGray,
  colorSecondary,
  colorPrimary,
  colorWhite,
} from 'styles/variables';

const height = '38px';
const lineHeight = '16px';

export const StateIcon = styled.span`
  display: none;
  position: absolute;

  &[data-invalid='true'] {
    display: inline-flex;
    height: 20px;
    width: 30px;
    justify-content: center;
    align-items: center;
    top: 11px;
    right: 2px;

    ::after {
      align-items: center;
      background-color: ${colorSecondary};
      border-radius: 50%;
      color: ${colorWhite};
      content: '!';
      display: flex;
      font-size: 10px;
      font-weight: 900;
      height: 14px;
      width: 14px;
      justify-content: center;
    }
  }

  &[data-valid='true'] {
    display: inline-flex;
    top: 19px;
    right: 18px;

    ::after {
      content: '';
      display: block;
      border-color: ${colorPrimary};
      border-style: solid;
      border-width: 0 2px 2px 0;
      height: 11px;
      transform: rotate(45deg) translateY(-50%);
      transform-origin: right;
      width: 7px;
    }
  }
`;

export const Placeholder = styled.span`
  position: absolute;
  top: calc(50% - ${lineHeight} / 2);
  left: 0;
  display: inline-block;
  pointer-events: none;
  line-height: ${lineHeight};
  margin-left: ${({ withIcon }) => (withIcon ? '40px' : '16px')};
  padding: 0 2px;
  font-size: 14px;
  color: ${colorGray};
  white-space: nowrap;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  z-index: 3000000003;
`;

const placeholderTranslate = `
  ~ ${Placeholder} {
      margin-left: 16px;
      font-size: 10px;
      line-height: 12px;
      transform: translate(0, -1.8em);
    }
`;

const placeholderAccentLight = `
  ~ ${Placeholder} {
    color: ${colorPrimary} !important;
  }
`;

const hideExtends = `
  ~ ${StateIcon} {
    display: none;
  }
`;

export const Input = styled.input`
  box-sizing: border-box;
  width: ${({ withIcon }) => (withIcon ? 'calc(100% - 32px)' : '100%')};
  height: ${height};
  background: ${colorWhite};
  font-size: 16px;
  border: 0;
  color: ${colorBlack900};
  line-height: ${height};
  resize: none;
  outline: none;
  padding: 0 16px;
  padding-left: ${({ withIcon }) => (withIcon ? '8px' : '16px')};

  &:focus {
    font-size: initial;
  }
`;

export const Label = styled.label`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid ${colorBlueGray};
  border-radius: 2px;

  &:after {
    content: '';
    position: absolute;
    top: -5px;
    bottom: -5px;
    left: -1px;
    right: -1px;
    z-index: 1;
  }

  &[data-invalid='true'] {
    border-color: ${colorSecondary};
    padding-right: 25px;

    ${Placeholder} {
      color: ${colorSecondary};
    }
  }

  &[data-invalid='true'] ${/* sc-selector */ Input}[value=''] {
    ~ ${Placeholder} {
      color: ${colorGray};
    }
  }

  &[data-valid='true'] {
    border-color: ${colorPrimary};
    padding-right: 25px;

    ${Placeholder} {
      color: ${colorPrimary};
    }
  }

  ${/* sc-selector */ Input}:disabled {
    background-color: ${colorGrayLight};

    ~ ${Placeholder} {
      background-color: ${colorGrayLight};
    }
  }

  ${/* sc-selector */ Input}:focus {
    padding-right: 16px;

    ${hideExtends}

    ${placeholderAccentLight}
  }

  &:focus-within {
    border-color: ${colorPrimary};
  }

  ${/* sc-selector */ Input}:focus,
  ${/* sc-selector */ Input}:not([value='']) {
    ${placeholderTranslate}
  }

  ${/* sc-selector */ Input}:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
  }

  ${/* sc-selector */ Input}:-webkit-autofill:focus,
  ${/* sc-selector */ Input}:-webkit-autofill:active,
  &:not([data-valid='true']) ${/* sc-selector */ Input}:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
    padding-right: 16px;

    ${hideExtends}

    ${placeholderTranslate}
  }

  &[data-invalid='true'] ${
    /* sc-selector */ Input
  }:-webkit-autofill:not(:focus):not([value='']) {
    ~ ${StateIcon} {
      display: inline-flex;
    }
  }
`;

export const IconWrapper = styled.span`
  display: inline-block;
  margin: -2px 0 0 16px;
`;
